import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { PlacementsOtherinfoRoutingModule } from './hkbkplacements-otherinfo-routing.module';
import { PlacementsOtherinfoListComponent } from './placements-otherinfo-list/placements-otherinfo-list.component';
import { PlacementsOtherinfoCreateComponent } from './placements-otherinfo-create/placements-otherinfo-create.component';

@NgModule({
  declarations: [PlacementsOtherinfoListComponent, PlacementsOtherinfoCreateComponent],
  imports: [
    CommonModule,
    PlacementsOtherinfoRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class PlacementsOtherinfoModule { }
